import { axiosPost, axiosPut } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import displayGenError from 'shared/utils/displayGenError'
import setFormValidationError from 'shared/utils/setFormValidationError'
import loadPages from 'utils/loadPages'
import { getCustomData } from 'shared/components/App/Auth'
import Store from 'redux/Store'
import { setMenuPages } from 'shared/redux/actions'
import { setLastUrl } from 'shared/redux/actions'
import sortEntitiesByParent from './sortEntitiesByParent'
import Entity from 'components/AddRemoveTableSortable/types/Entity'

interface submitFormProps {
  data: any
  setShowOverlay: Function
  id: string | undefined
  setError: Function
  extraData?: any
}

const submitForm = async (props: submitFormProps) => {
  let response: any = false

  const formData = {
    ...props.data,
  }

  const catchFunc = (err: AxiosError) => {
    if (err.response!.status === 422) {
      const mappedAttributes: Map<string, string> = new Map()
      mappedAttributes.set('url', 'url')
      setFormValidationError(err, props.setError, mappedAttributes, 'name')
    } else {
      displayGenError({ setShowOverlay: props.setShowOverlay })
    }
  }

  if (props.id === undefined) {

    const sortedFilters : Array<Entity & {filter_id : number}> = sortEntitiesByParent(props.extraData.filters)
    const reportIds: Array<number> = props.extraData.reports.map((p) => p.report_id)
    const filterIds: Array<number> = sortedFilters.map((f) => f.filter_id)

    response = await axiosPost(apiUrls.pages, formData, catchFunc).then(async (data) => {
      if (data?.status !== undefined && data.status === 201) {
        reportIds.forEach((reportId) => {
          axiosPost(
            apiUrls.pagesToReports,
            {
              report_id: reportId,
              page_id: data.data.id,
            },
            catchFunc,
          )
        })
        for (const filterId of filterIds) {
          await axiosPost(
            apiUrls.filtersToPages,
            {
              filter_id: filterId,
              page_id: data.data.id,
            },
            catchFunc,
          )
        }
      }
      return data
    })
  } else {
    response = await axiosPut(apiUrls.pages + '/' + props.id, formData, catchFunc)
  }

  // reload stored pages
  if (response?.status !== undefined && [200, 201].includes(response.status)) {
    loadPages({
      role: getCustomData('role'),
      customer: getCustomData('customer') ?? false,
      loadFromServer: true
    }).then((pages) => {
      Store.dispatch(setMenuPages(pages))
    })
  }

  // change saved last URL if needed
  if (
    props.data?.url &&
    props.extraData?.initUrl &&
    props.extraData.initUrl !== props.data.url &&
    props.extraData?.lastUrl.user === '/' + props.extraData?.initUrl
  ) {
    const lastUrl = []
    lastUrl['user'] = '/' + props.data.url
    Store.dispatch(setLastUrl(lastUrl))
  }

  return response
}

export default submitForm
